<div class="container info-section">
    <br>
    <h1>Wodoxi</h1>
    <p>É um aplicativo produzido por Andlline Software (Alline Susan Paz de Menezes) e propriedade de Alline Susan Paz de Menezes</p>
    <div class="contact-info">
        <p><i class="fas fa-phone-alt"></i>Tel para contato: <a href="tel:+5581996280325">81 99628-0325</a></p>
    </div>
</div>

<style>
    .info-section {
        margin-top: 50px;
        text-align: center;
    }
    .info-section h1 {
        font-size: 2.5em;
        margin-bottom: 20px;
    }
    .info-section p {
        font-size: 1.2em;
    }
    .contact-info {
        margin-top: 20px;
        font-size: 1.1em;
    }
    .contact-info i {
        margin-right: 10px;
    }
</style>